import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {ChecklistenPage} from './checklisten.page';
import {TranslateModule} from '@ngx-translate/core';
import {EffectsModule} from '@ngrx/effects';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {ChecklistenPageUiEffects} from './checklisten.effects.ui';
import {StoreModule} from '@ngrx/store';
import {reducers} from './checklisten.reducer';
import {
    VorlagenAufgabeAktualisierenEffects,
    VorlagenAufgabeAnlegenEffects, VorlagenAufgabeKopierenEffects,
    VorlagenAufgabeLoeschenEffects, VorlagenAufgabeReihenfolgenEffects, VorlagenAufgabeVerschiebenEffects,
    VorlagenChecklisteAktualisierenEffects,
    VorlagenChecklisteAnlegenEffects,
    VorlagenChecklisteAufgabenEffects,
    VorlagenChecklisteDetailEffects, VorlagenChecklisteKopierenEffects,
    VorlagenChecklisteLoeschenEffects, VorlagenChecklisteReihenfolgenEffects, VorlagenChecklisteVeranstaltungsTypenAktivierenEffects, VorlagenChecklisteVeranstaltungsTypenDeaktivierenEffects, VorlagenChecklisteVeranstaltungsTypenEntfernenEffects, VorlagenChecklisteVeranstaltungsTypenHinzufuegenEffects, VorlagenChecklisteVerschiebenEffects,
    VorlagenFunktionsbereichChecklistenEffects, VorlagenFunktionsbereicheChecklistenEffects, VorlagenFunktionsbereicheRollenEffects
} from '../../../client-ngrx/vorlagen';
import {
    BenutzerverwaltungFunktionsbereicheEffects
} from '../../../client-ngrx/benutzerverwaltung';
import {EffectsWs} from './checklisten.effects.ws';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PandemieAufgabePandemieLevelSetzenEffects, PandemieChecklistePandemieLevelInfoEffects} from '../../../client-ngrx/pandemie';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';
import {SopiDirectivesModule} from '../../../sopi/directives/sopi-directives.module';

const routes: Routes = [
    {
        path: '',
        component: ChecklistenPage,
        data: {title: 'Checklisten verwalten'}
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule,
        StoreModule.forFeature('ChecklistenPage', reducers),
        EffectsModule.forFeature([
            ChecklistenPageUiEffects,
            EffectsWs,

            // Vorlagen Get
            VorlagenChecklisteDetailEffects,
            VorlagenChecklisteAufgabenEffects,
            VorlagenFunktionsbereichChecklistenEffects,
            VorlagenFunktionsbereicheChecklistenEffects,
            VorlagenFunktionsbereicheRollenEffects,

            // Vorlagen Posts
            VorlagenAufgabeAktualisierenEffects,
            VorlagenAufgabeAnlegenEffects,
            VorlagenAufgabeLoeschenEffects,
            VorlagenChecklisteAktualisierenEffects,
            VorlagenChecklisteAnlegenEffects,
            VorlagenChecklisteLoeschenEffects,
            VorlagenChecklisteKopierenEffects,
            VorlagenChecklisteVerschiebenEffects,
            VorlagenChecklisteReihenfolgenEffects,
            VorlagenAufgabeKopierenEffects,
            VorlagenAufgabeVerschiebenEffects,
            VorlagenAufgabeReihenfolgenEffects,
            VorlagenChecklisteVeranstaltungsTypenAktivierenEffects,
            VorlagenChecklisteVeranstaltungsTypenDeaktivierenEffects,
            VorlagenChecklisteVeranstaltungsTypenEntfernenEffects,
            VorlagenChecklisteVeranstaltungsTypenHinzufuegenEffects,

            // Pandemie Gets
            PandemieChecklistePandemieLevelInfoEffects,

            // Pandemie Posts
            PandemieAufgabePandemieLevelSetzenEffects,

            // Get Benutzerverwaltung
            BenutzerverwaltungFunktionsbereicheEffects,
        ]),
        SopiScrollModule,
        DragDropModule,
        SopiComponentsModule.forRoot(),
        SopiDirectivesModule
    ],
    declarations: [ChecklistenPage],
    entryComponents: [ChecklistenPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChecklistenPageModule {
}
